// 見頃カレンダーポップアップ機能
document.addEventListener('DOMContentLoaded', function () {
  // 詳細ボタンのクリックイベント
  document.querySelectorAll('.calendar__readMoreButton').forEach(button => {
    button.addEventListener('click', function () {
      const spotId = this.getAttribute('data-flower-spot-id');
      const popup = document.getElementById(`popup-${spotId}`);
      popup.style.display = 'flex';
    });
  });

  // 閉じるボタンのクリックイベント
  document.querySelectorAll('.calendar__popupClose').forEach(button => {
    button.addEventListener('click', function () {
      const spotId = this.getAttribute('data-flower-spot-id');
      const popup = document.getElementById(`popup-${spotId}`);
      popup.style.display = 'none';
    });
  });

  // ポップアップ外クリックで閉じる
  document.querySelectorAll('.calendar__popup').forEach(popup => {
    popup.addEventListener('click', function (event) {
      // ポップアップコンテンツ以外をクリックした場合
      if (event.target === this) {
        this.style.display = 'none';
      }
    });
  });
});